import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { EnvSiteConfig } from '../types'

const envSiteConfig: SiteConfigFn<EnvSiteConfig> = ({ api, funcLib }) => {
	const domain = api.publicModel.getDomain()
	const url = api.originalRequest.getUrl() ?? ''
	const editorType = (funcLib.getQueryParamValue(url, 'editorType') || '').toLowerCase()
	const previewMode = api.rendererModel.getPreviewMode()
	const isBuilderComponentModel = !!api.rendererModel.getSiteMetaData()?.builderComponentModel

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			editorType,
			domain,
			previewMode,
			isBuilderComponentModel,
		},
	}
}

const name = 'environment'

export const config = { site: envSiteConfig, name }
